function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361 76",
    style: {
      enableBackground: "new 0 0 361 76"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 309.223,
    y1: 39.712,
    x2: 333.637,
    y2: 39.712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d89fd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#723dff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(324 26)",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#logo_svg__a)"
    },
    d: "M-13.3 15.6c-1.1.4-1.7 1.6-1.4 2.8.4 1.2 1.6 1.8 2.8 1.4 1.2-.4 1.8-1.6 1.4-2.8-.3-.9-1.1-1.5-2.1-1.5-.2 0-.4 0-.7.1m7.7-3.4c-1.6.5-2.5 2.3-2 3.9s2.3 2.5 3.9 2 2.5-2.3 2-3.9c-.4-1.4-1.6-2.2-3-2.2-.3 0-.6.1-.9.2m9.4-4.5C1.5 8.5.2 11 1 13.3c.8 2.3 3.2 3.6 5.6 2.8 2.3-.8 3.6-3.2 2.8-5.6-.7-1.8-2.4-3-4.2-3-.5 0-1 .1-1.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#13223d"
    },
    d: "M0 58h11V18H0v40zm28.2-20.5v20.1H18.1V16.7c0-.4.2-.7.8-.1l25.4 20.9V17.2h10.2v41c0 .5-.2.7-.8.1L28.2 37.5zm33.2-20.3h27.5v9.1H72.2v8.2h14.7v9.1H72.2v14H61.4V17.2zm32.8 0H105v31.3h17.2v9.1h-28V17.2zM125.3 42V17.2h10.8v24.6c0 4.6 2.1 7.2 6.7 7.2s6.7-2.6 6.7-7.2V17.2h10.8V42c0 10.9-7.4 16.2-17.5 16.2s-17.5-5.3-17.5-16.2m142.3-5.3c3.7 0 5.6-1.8 5.6-5.2 0-3.3-2-5.2-5.6-5.2h-5v10.3l5 .1zm-5 20.9h-10.8V17.2h16.3c10.3 0 16 6.1 16 14.3 0 5.3-2.6 9.6-7.4 11.8l8.4 14.3h-11.7L266.2 45h-3.7v12.6h.1zm-62.5-20.1-11.7-20.2h-20.7v9.1h17.6v6.7h-14.7v8.6h14.7v6.9h-18.4v9.1h21.5l11.7-20.2zm28.5 11.1v-6.9h14.6v-8.6h-14.6v-6.7h17.5v-9.1h-20.6l-11.7 20.2 11.7 20.2H247v-9.1h-18.4zm-21.7-18.7 6.1-12.7h-12.2l6.1 12.7zm.1 15-6.1 12.6H213l-6-12.6zm139.9-22.8 5.9 18.2c.1.2.3.3.5.2 2.5-1.7 3.3-6.3 1.8-11s-4.9-8-7.9-7.9c-.3.1-.4.3-.3.5m-1 28.7h-29.2l-4.7 4.8-.1-4.7h-15.4l-1.4-4.3 40-28.9 10.8 33.1zm-58.4-6.1 4 12.2c.1.4.4.6.8.6h13.2l.3 11.7c0 .7.9 1.1 1.5.6l12.2-12.3H354c.5 0 .9-.5.7-1L339 8.2c-.2-.5-.8-.8-1.3-.4l-49.8 36c-.3.2-.5.6-.4.9z"
  }));
};
export default SvgLogo;